/**
 * Converts GBP amount to USDC smallest unit (6 decimals).
 * Uses a fixed exchange rate for now.
 *
 * @param gbpAmount - Amount in GBP
 * @returns Amount in USDC smallest unit (6 decimals)
 */
const GBP_TO_USD_RATE = 1.27;

export const gbpToUsdc = (gbpAmount: number): number => {
  // USDC has 6 decimal places
  // We ceil to ensure we don't underpay
  return Math.ceil(gbpAmount * GBP_TO_USD_RATE * 1_000_000);
};

/**
 * Formats USDC amount for display (converts from smallest unit to dollars).
 *
 * @param usdcAmount - Amount in USDC smallest unit (6 decimals)
 * @returns Formatted string like "$1.27"
 */
export const formatUsdcAmount = (usdcAmount: number): string => {
  return `$${(usdcAmount / 1_000_000).toFixed(2)}`;
};

